import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetRoles } from 'domains/Role/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../ApplicationFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const RoleFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [roles] = useGetRoles()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'role',
    operand: '=='
  })

  return (
    <StyledDetails
      open={localStorage.getItem(`role-details-visibility`) === 'opened'}>
      <summary style={summaryStyles} onClick={() => onToggleDetails('role')}>
        {t('Role')}
      </summary>
      {roles?.map((role, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(role)}
            onChange={() => onChange(role)}>
            <Text wordBreak="break-all">
              {role?.name || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

RoleFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default RoleFilter
